<app-dialog-layout class="dialog-layout madar--v2">
  <section>
    <mat-card class="bg-100">
      <mat-card-content class="px-2 text-center">
        <div dialog-title>
          <div class="mb-3">
            <img width="360" height="150" src="assets/images/tour-complete-animation.gif" alt="tour-complete-animation">
          </div>
          
          <div class="mb-3 h5 text-accent weight-semibold">{{ 'shared.TourGuideCompleteTitle' | translate }}</div>
          <div innerHTML="{{'shared.TourGuideCompleteSubTitle' | translate}}"></div>
        </div>

        <mat-divider class="my-3 text-300"></mat-divider>

        <div dialog-content>
          <ng-container *ngFor="let tour of data">
            <div class="flex align-center">
              <app-icon class="mr-3 mb-1" name="outline-tick-circle" size="xs"
                [ngClass]="{'text-300': !tour.isVisited, 'text-success': tour.isVisited }">
              </app-icon>
          
              <span class="w-100 flex justify-space-between">
                <span class="h6 mb-0 text-900 text-start text-ellipsis-2 h-50" [matTooltip]="tour?.title?.length > 65 ? tour?.title : ''" [matTooltipPosition]="'left'">{{ tour?.title }}</span>
                <span class="small text-primary-200 cursor-pointer" (click)="takeTour.emit(tour)">{{ (tour.isVisited ? 'shared.ReplayTour' : 'shared.GetStarted') | translate }}</span>
              </span>
            </div>
            <mat-divider class="my-3 text-300"></mat-divider>
          </ng-container>
        </div>
      </mat-card-content>
    </mat-card>
  </section>
  <div dialog-action class="w-100">
    <app-row gutter="x-xs" class="justify-center mt-4">
      <app-col cols="8">
        <button mat-flat-button mat-dialog-close class="w-100 bg-white text-primary brd brd-primary-light">
          {{ "shared.Maybelater" | translate }}
        </button>
      </app-col>
    </app-row>
  </div>
</app-dialog-layout>